import { useWebStore } from '@/store/web.js'
import { useRoute } from '#app';
import { findSiteByUrl } from '~/utils/siteNavigation'
export default function () {
  const store = useWebStore();
  const route = useRoute();
  // A legal/impresszum oldalak nincsenek a `sites` listában, ezért a keresés
  // undefined-ot adhat — a guard nélkül a layout onMounted hookja elhalna.
  // A `findSiteByUrl` a `children` alatti al-oldalakat is megtalálja, így a
  // gépgyártás al-oldalain is helyes a title és a meta.
  const current = findSiteByUrl(store.sites, store.chosenTab);
    useHead({
      title: store.titleBase + (current?.text ?? ''),
      meta: [
        {
          name: current?.metaName ?? 'Poliol Kft.',
          content: current?.metaContent ?? 'Poliol Kft.',
        },
      ],
      link: [
        { rel: 'canonical', href: `https://poliol.hu${route.path}` }
      ],
  });
}
